import AppLayout from '@src/layouts/appLayout';
import { createBrowserRouter } from 'react-router-dom';
import Home from '@src/pages/home';
import AuthLayout from '@src/layouts/auth';
import { authRoutes } from './subRoutes/authRoutes';
import NotFound from '@src/pages/notFound';
import GeneralLayout from '@src/layouts/general';
import { generalRoutes } from './subRoutes/generalRoutes';
import { onboardingRoutes } from './subRoutes/onboardingRoutes';
import { receiverRoutes } from './subRoutes/receiverRoutes2';
import DashboardLayout from '@src/layouts/dashboard';
import { senderRoutes, senderRoutes2 } from './subRoutes/senderRoutes2';
import PlainLayout from '@src/layouts/plain';
import lazyWithPreload from '@src/utils/lazyWithPreload';
import { Path } from './routes';
import SuspenseWrapper from '@src/components/suspenseWrapper';
import Error from '@src/pages/error';
import Loader from '@src/components/loader';
import ErrorBoundary from '@src/components/errorBoundary';

const PaymentLinkUsage = lazyWithPreload(() => import('@src/pages/paymentLinkUsage'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        element: <AuthLayout />,
        children: authRoutes
      },
      // {
      //   element: <AuthLayout showAside={false} />,
      //   children: authRoutes2
      // },
      {
        element: <AuthLayout showAside={false} asideContent={null} isProtected />,
        children: onboardingRoutes
      },
      {
        element: <GeneralLayout />,
        children: generalRoutes
      },
      {
        element: <DashboardLayout client="receiver" setFixedMainWidth />,
        children: receiverRoutes
      },
      {
        element: <DashboardLayout client="sender" setFixedMainWidth />,
        children: senderRoutes
      },
      {
        element: <PlainLayout />,
        children: senderRoutes2
      },
      {
        path: `${Path.PaymentLinkUsage}/:reference`,
        element: (
          <SuspenseWrapper
            errorFallback={({ resetError }) => <Error resetError={resetError} />}
            suspenseFallback={<Loader className="" showTimedOutScreen />}>
            <PaymentLinkUsage />
          </SuspenseWrapper>
        )
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
]);
